import { Box, Stack, Typography } from '@mui/material';

const NoDentistFound = () => {
  return (
    <Box>
      <Stack alignItems="center">
        <Box className="col-md-8 col-sm-12">
          <Typography
            component="h2"
            fontSize="4rem"
            textTransform="capitalize"
            textAlign="center"
          >
            Office Not Found
          </Typography>

          <Typography fontSize="1.25rem" textAlign="center">
            Unfortunately there is no office associated with this signup link.
            Please double check the website address (URL) in your browser and
            make sure it matches the link that you were provided. If this does
            not resolve the issue, please contact your office. They will be able
            to send you a new signup link.
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default NoDentistFound;
